export default {
  number: 'מספר תיק',
  addNewClient: 'הוספת תיק',
  accordType: 'סוג תיק',
  branch: 'מוצר',
  uid: 'מספר תיק',
  company: 'חברה מנהלת',
  commission: 'עמלת סוכן %',
  comments: 'הערות',
  clientName: 'שם לקוח',
};
